import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const PassengerDetailInputField = ({
  label,
  inputType,
  icon,
  placeHolder,
  onChange,
  inputRef,
  onClick,
  value,
  onFocus,
  onBlur,
  onfocusout,
  className,
}) => {
  return (
    <div className="grow">
      <div className="text-stone-600 px-0.5 text-lg font-normal">{label}</div>
      <div className="flex items-center border-b  border-gray-500 py-2">
        <FontAwesomeIcon icon={icon} className="w-5 text-gray-500" />
        <input
          className={
            className
              ? className
              : "appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-1 leading-tight focus:outline-none"
          }
          type={inputType}
          placeholder={placeHolder}
          onChange={onChange}
          ref={inputRef}
          onClick={onClick}
          value={value}
          onFocus={onFocus}
          onBlur={onBlur}
          onfocusout={onfocusout}
        />
      </div>
    </div>
  );
};

export default PassengerDetailInputField;
